import React, { useState, useEffect } from "react";
import { PropTypes } from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import { useParams } from "react-router-dom";

import { getCustomJSON, checkCustomJSON } from "api/legacy/PlatformAPI";
import { notifError } from "actions/FlashMessageActions";

import UploadButton from "components/utils/UploadButton";
import DownloadFileButton from "components/utils/DownloadFileButton";

function SignupCustomUpload({ project, changeProjectParams }) {
  const { token } = useSelector((state) => state.loginReducer);
  const dispatch = useDispatch();
  const { t } = useTranslation("editor-platform");
  const { projectSlug } = useParams();

  const [customJSON, setCustomJSON] = useState(null);
  const [progress, setProgress] = useState(0);
  const [uploadComplete, setUploadComplete] = useState(false);
  const [uploadStart, setUploadStart] = useState(false);

  useEffect(() => {
    getCustomJSON(token, projectSlug, (json) => {
      if (Object.keys(json?.data).length > 0) {
        setCustomJSON(json?.data);
      }
    });
  }, [projectSlug]);

  const onSelectFile = (file) => {
    if (file) {
      setUploadStart(true);

      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileInfo = {
          name: file.name,
          type: file.type,
          size: file.size,
          base64: reader.result,
        };

        onUploadJSON(fileInfo);
      };
    }
  };

  const onUploadJSON = (file) => {
    checkCustomJSON(
      file,
      token,
      projectSlug,
      customOnUploadProgress,
      (json) => {
        setTimeout(() => {
          setProgress(0);
          setUploadComplete(true);
          setUploadStart(false);
        }, 1000);

        changeProjectParams("user_custom_values", json?.data);
      },
      ({ response }) => {
        setProgress(0);
        setUploadComplete(false);
        setUploadStart(false);

        if (response && response.status == 413) {
          dispatch(notifError(t("editor-errors:errorUploadSize")));
        } else {
          dispatch(notifError(t("editor-errors:errorUpload")));
        }
      },
    );
  };

  const customOnUploadProgress = (ev) => {
    const percentCompleted = Math.floor((ev.loaded * 100) / ev.total);
    setProgress(percentCompleted);
  };

  return (
    <div className="editor-form-section section-separator">
      <div className="editor-form-section-title">{t("signupCustomFile")}</div>
      {!!customJSON && (
        <div className="editor-form-row editor-form-row-inline m-t-20">
          <div className="editor-form-label m-t-0">
            {t("customFileAlreadySend")}{" "}
            <span className="m-l-5 italic">custom_inputs.json</span>
          </div>
          <DownloadFileButton
            filename="custom_inputs.json"
            datas={JSON.stringify(customJSON, null, "\t")}
            type="application/json"
            icon={<CloudDownloadIcon />}
          />
        </div>
      )}

      <div className="editor-form-row editor-form-row-inline m-t-0 font-semibold text-white">
        <UploadButton
          upload={onSelectFile}
          percentProgress={progress}
          uploadComplete={uploadComplete}
          uploadStart={uploadStart}
          btnLabel={t("uploadLabel")}
        />
        {uploadComplete && (
          <div className="editor-form-label">{t("customFileValid")}</div>
        )}
      </div>
    </div>
  );
}

SignupCustomUpload.propTypes = {
  project: PropTypes.object.isRequired,
  changeProjectParams: PropTypes.func.isRequired,
};

export default SignupCustomUpload;
